import { Controller } from "@hotwired/stimulus"
import Choices from "choices.js";

// Connects to data-controller="choice-select"
export default class extends Controller {
  static targets = ["select"]

  connect() {
    this.selectTargets.forEach(select => {
      const choices = new Choices(select, {
        removeItemButton: true,
        duplicateItemsAllowed: false,
        searchEnabled: true,
        placeholderValue: "Select an option",
        noResultsText: "No results found",
        classNames: {
          containerInner: ["flex", "flex-wrap", "gap-0", "form-input", "rounded-md", "text-sm", "w-full"],
        },
      })
    })
  }
}
